'use client'

import React from 'react'

import { Box, HTMLChakraProps, Text } from '@chakra-ui/react'

import {
  ColorScheme,
  infoBoxLabelStyles,
  infoBoxStyles,
  infoBoxValueStyles,
} from './InfoBox.styles'

export type { ColorScheme }

export type InfoBoxProps = HTMLChakraProps<'div'> & {
  label: string
  value: string
  colorScheme?: ColorScheme
}

export const InfoBox = ({
  label,
  value,
  colorScheme = 'dark',
  ...rest
}: InfoBoxProps) => (
  <Box overflow='hidden' px='20px' w='full' {...rest}>
    <Box {...infoBoxStyles(colorScheme)}>
      <Text {...infoBoxLabelStyles(colorScheme)}>{label}</Text>
      <Text {...infoBoxValueStyles(colorScheme)}>{value}</Text>
    </Box>
  </Box>
)
